module.exports = __webpack_public_path__ + "static/img/a023.1b5ae30.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a023.jpg
// module id = opuc
// module chunks = 0